import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54c60612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tasks" }
const _hoisted_2 = ["onMouseleave", "onMouseover", "onClick"]
const _hoisted_3 = ["data-bs-target"]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = { class: "form-check form-switch" }
const _hoisted_7 = ["id", "onUpdate:modelValue"]
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "ms-4 form-check form-switch" }
const _hoisted_10 = ["id", "onUpdate:modelValue"]
const _hoisted_11 = ["for"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "form-check form-switch" }
const _hoisted_14 = ["id", "onUpdate:modelValue"]
const _hoisted_15 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_context_menu = _resolveComponent("context-menu")!
  const _component_arrow_icon = _resolveComponent("arrow-icon")!
  const _component_help_tooltip = _resolveComponent("help-tooltip")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_draggable, {
      modelValue: _ctx.computedTasks,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedTasks) = $event)),
      group: "tasks",
      tag: "div",
      onStart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drag = true)),
      onEnd: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drag = false)),
      "item-key": "taskId"
    }, {
      item: _withCtx(({ element, index }) => [
        _createElementVNode("div", {
          class: "task",
          onMouseleave: ($event: any) => (_ctx.hoverTask[`${_ctx.jobId}-${index}`] = false),
          onMouseover: ($event: any) => (_ctx.hoverTask[`${_ctx.jobId}-${index}`] = true),
          onClick: ($event: any) => {
            _ctx.selectedTask = element;
            _ctx.$emit('selectedTask', element);
          }
        }, [
          (_ctx.hoverTask[`${_ctx.jobId}-${index}`])
            ? (_openBlock(), _createBlock(_component_context_menu, {
                key: 0,
                class: "me-4",
                icon: "edit",
                size: "13",
                id: `${_ctx.jobId}-${index}`,
                links: [
              {
                text: 'Rename',
                icon: 'edit',
                bsTarget: '#taskUpdateModal',
              },
              {
                text: 'Edit form',
                icon: 'external-link',
                hidden: element.type !== 'FORM',
                router: `/project/task-form/${_ctx.$route.params.projectId}/${_ctx.jobId}/${element.taskId}`,
              },
              {
                text: 'Delete',
                icon: 'trash-2',
                bsTarget: '#taskDeleteModal',
              },
            ]
              }, null, 8, ["id", "links"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "cursor-pointer collapsed",
            "data-bs-toggle": "collapse",
            "data-bs-target": `#taskMore${_ctx.jobId}-${index}`
          }, [
            _createElementVNode("h6", {
              class: _normalizeClass(["subtitle", element.type])
            }, [
              _createVNode(_component_arrow_icon, { class: "mt-2 float-end arrow-icon" }),
              _createTextVNode(" " + _toDisplayString(element.name), 1)
            ], 2)
          ], 8, _hoisted_3),
          _createElementVNode("div", {
            class: "collapse",
            id: `taskMore${_ctx.jobId}-${index}`
          }, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("textarea", {
                class: "mt-3 mb-1",
                "onUpdate:modelValue": ($event: any) => ((element.description) = $event),
                placeholder: "Task description"
              }, null, 8, _hoisted_5), [
                [_vModelText, element.description]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: `user-addable-${index}`,
                  "onUpdate:modelValue": ($event: any) => ((element.config.active) = $event)
                }, null, 8, _hoisted_7), [
                  [_vModelCheckbox, element.config.active]
                ]),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: `user-addable-${index}`
                }, [
                  _createTextVNode("Active "),
                  _createVNode(_component_help_tooltip, {
                    position: "bottom",
                    text: "This option makes this task be active by default. Otherwise it can be added later."
                  })
                ], 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: `mandatory-${index}`,
                  "onUpdate:modelValue": ($event: any) => ((element.config.mandatory) = $event)
                }, null, 8, _hoisted_10), [
                  [_vModelCheckbox, element.config.mandatory]
                ]),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: `mandatory-${index}`
                }, [
                  _createTextVNode("Mandatory "),
                  _createVNode(_component_help_tooltip, {
                    position: "bottom",
                    text: "This task must be completed before the job can be marked as done."
                  })
                ], 8, _hoisted_11)
              ]),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: `user-addable-${index}`,
                  "onUpdate:modelValue": ($event: any) => ((element.config.userAddable) = $event)
                }, null, 8, _hoisted_14), [
                  [_vModelCheckbox, element.config.userAddable]
                ]),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: `user-addable-${index}`
                }, [
                  _createTextVNode("User addable "),
                  _createVNode(_component_help_tooltip, {
                    position: "bottom",
                    text: "User addable means this job can be added (multiple times) to a project by anyone."
                  })
                ], 8, _hoisted_15)
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["task-type mt-2", element.type])
            }, _toDisplayString(_ctx.transformTaskTypes(element.type)), 3)
          ], 8, _hoisted_4)
        ], 40, _hoisted_2)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}